module.exports = __webpack_public_path__ + "img/blue.bf0f6af8.svg";